/*
 * @Author: Teemo Ding
 * @Date: 2021-04-22 13:43:17
 * @LastEditTime: 2021-07-14 14:59:14
 * @LastEditors: Luke Z
 * @Description: salesChannel Product types
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/salesChannelProduct.ts
 */
import { ILinkModule } from './linkType';
import { EnumModuleType, EnumCarouselOptions } from './module';
import { getI18nFromGeneral } from 'src/tools/tools';

export interface ProductSeoSetting {
  title: string;
  description: string;
  urlSlug: string;
  customized: boolean;
}

export enum EnumLinkProductType {
  Single = 'Single',
  Multiple = 'Multiple',
  GiftCard = 'GiftCard',
  Service = 'Service',
}

export enum EnumLinkProductType1 {
  SinglePhysical = 'SinglePhysical',
  SingleService = 'SingleService',
  SingleGiftCard = 'SingleGiftCard',
  MultiplePhysical = 'MultiplePhysical',
  MultipleVirtual = 'MultipleVirtual',
}

export const typeDict = {
  [EnumLinkProductType1.MultiplePhysical]: getI18nFromGeneral(
    'general.status.multiplePhy',
  ),
  [EnumLinkProductType1.SinglePhysical]: getI18nFromGeneral(
    'general.status.singlePhy',
  ),
  [EnumLinkProductType1.SingleService]: getI18nFromGeneral(
    'general.status.singleSer',
  ),
  [EnumLinkProductType1.SingleGiftCard]: getI18nFromGeneral(
    'general.status.singleGC',
  ),
  [EnumLinkProductType1.MultipleVirtual]: getI18nFromGeneral(
    'general.status.multipleVir',
  ),
};

export interface LongCanvasModule {
  moduleName: string;
  moduleType: EnumModuleType;
  visible: boolean;
  linkModules: ILinkModule[];
}

export interface ProductContentCarousel {
  moduleName: string;
  moduleType: EnumModuleType;
  visible: boolean;
  sameAsOriginal: boolean;
  carousel: ProductContentCarouselModule;
}

export interface ProductContentCarouselModule {
  moduleName: string;
  moduleType: EnumModuleType;
  visible: boolean;
  posterType: EnumCarouselOptions;
  autoPlay: boolean;
  intervalTime: number;
  linkModules: ILinkModule[];
  contentLinkModule: ProductContentLinkModule;
}

export interface ProductContentLinkModule {
  linkModule: ILinkModule;
  coverImage: boolean;
}
